import * as Yup from 'yup';
import { boolean, date, number, object, string } from 'yup';

export type IResidentPrivatePayerInvoicingConfig = {
  id: string;
  nursingHomeId: string;
  residentId: string;
  validFrom: Date;
  email?: string | null;
  supervisorId: string | null;
  costBearerId: string;
  createdAt: Date;
  fibuDebtorAccount: string;
  sepaDate: Date | null;
  isMandate: boolean;
  mandateDate: Date | null;
  mandateReference?: string | null;
  sendInvoiceByEmail: boolean;
  accountOwner?: string | null;
  iban?: string | null;
  bic?: string | null;
  pocketIsMandate: boolean;
  pocketMandateDate?: Date | null;
  pocketSepaDate?: Date | null;
  pocketMandateReference?: string | null;
  pocketAccountOwner?: string | null;
  pocketIban?: string | null;
  pocketBic?: string | null;
  pocketIsMonthlyGenerateEnabled: boolean;
  pocketMonthlyGenerateDate?: Date | null;
  pocketMonthlyGenerateIncoming?: number | null;
  pocketMonthlyGenerateRemark?: string | null;
};

export type IResidentPrivatePayerInvoicingConfigCreate = {
  validFrom: Date;
  email?: string | null;
  supervisorId: string | null;
  fibuDebtorAccount?: string;
  sepaDate?: Date | null;
  isMandate: boolean;
  mandateDate?: Date | null;
  mandateReference?: string | null;
  sendInvoiceByEmail: boolean;
  accountOwner?: string | null;
  iban?: string | null;
  bic?: string | null;
  pocketIsMandate: boolean;
  pocketMandateDate?: Date | null;
  pocketSepaDate?: Date | null;
  pocketMandateReference?: string | null;
  pocketAccountOwner?: string | null;
  pocketIban?: string | null;
  pocketBic?: string | null;
  pocketIsMonthlyGenerateEnabled: boolean;
  pocketMonthlyGenerateDate?: Date | null;
  pocketMonthlyGenerateIncoming?: number | null;
  pocketMonthlyGenerateRemark?: string | null;
};

export const IResidentPrivatePayerInvoicingConfigCreateSchema = object({
  validFrom: date().required(),
  email: string().optional().nullable(),
  supervisorId: string().optional().nullable(),
  fibuDebtorAccount: Yup.mixed().when('isMandate', {
    is: true,
    then: string().required(),
    otherwise: string().optional().nullable(),
  }),
  isMandate: boolean().required(),
  sendInvoiceByEmail: boolean().required(),
  sepaDate: Yup.mixed().when('isMandate', {
    is: true,
    then: date().required(),
    otherwise: date().optional().nullable(),
  }),
  mandateDate: Yup.mixed().when('isMandate', {
    is: true,
    then: date().required(),
    otherwise: date().optional().nullable(),
  }),
  mandateReference: Yup.mixed().when('isMandate', {
    is: true,
    then: string().required(),
    otherwise: string().optional().nullable(),
  }),
  accountOwner: Yup.mixed().when('isMandate', {
    is: true,
    then: string().required(),
    otherwise: string().optional().nullable(),
  }),
  iban: Yup.mixed().when('isMandate', {
    is: true,
    then: string().required(),
    otherwise: string().optional().nullable(),
  }),
  bic: Yup.mixed().when('isMandate', {
    is: true,
    then: string().required(),
    otherwise: string().optional().nullable(),
  }),
  pocketIsMandate: boolean().required(),
  pocketSepaDate: Yup.mixed().when('pocketIsMandate', {
    is: true,
    then: date().required(),
    otherwise: date().optional().nullable(),
  }),
  pocketMandateDate: Yup.mixed().when('pocketIsMandate', {
    is: true,
    then: date().required(),
    otherwise: date().optional().nullable(),
  }),
  pocketMandateReference: Yup.mixed().when('pocketIsMandate', {
    is: true,
    then: string().required(),
    otherwise: string().optional().nullable(),
  }),
  pocketAccountOwner: Yup.mixed().when('pocketIsMandate', {
    is: true,
    then: string().required(),
    otherwise: string().optional().nullable(),
  }),
  pocketIban: Yup.mixed().when('pocketIsMandate', {
    is: true,
    then: string().required(),
    otherwise: string().optional().nullable(),
  }),
  pocketBic: Yup.mixed().when('pocketIsMandate', {
    is: true,
    then: string().required(),
    otherwise: string().optional().nullable(),
  }),
  pocketIsMonthlyGenerateEnabled: boolean().required(),
  pocketMonthlyGenerateDate: Yup.mixed().when('pocketIsMonthlyGenerateEnabled', {
    is: true,
    then: date().required(),
    otherwise: date().optional().nullable(),
  }),
  pocketMonthlyGenerateIncoming: Yup.mixed().when('pocketIsMonthlyGenerateEnabled', {
    is: true,
    then: number().required(),
    otherwise: number().optional().nullable(),
  }),
  pocketMonthlyGenerateRemark: Yup.mixed().when('pocketIsMonthlyGenerateEnabled', {
    is: true,
    then: string().required(),
    otherwise: string().optional().nullable(),
  }),
});
